<template lang="pug">
v-btn.text-capitalize(
  @click="create",
  :loading="loading",
  outlined,
  small,
  color="secondary"
) Create Invoices
</template>

<script>
export default {
  data() {
    return { loading: false };
  },
  methods: {
    async create() {
      this.loading = true;
      try {
        const result = await this.$api.salesforce.invoice.create();
        this.$toast.success(result);
        this.$emit("created");
      } catch (err) {
        this.$toast.error(err.response?.data || err.response);
      }
      this.loading = false;
    },
  },
};
</script>